module.exports = ".input-group-text {\n  cursor: pointer; }\n"